module.exports = __webpack_public_path__ + "static/media/EventsAvater.f9f2ab3b.jpg";